var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 453.221 349.597",
    id: "ladyemployeeworkingintheoffice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c0f9e0",
    d: "M285.51547,347.87814c14.26693-4.46006,27.06766-9.0167,42.46717-17.66465,15.88239-8.92013,86.43567-51.36975,95.61041-124.83787a140.13686,140.13686,0,0,0-5.84725-59.8421c-2.83583-8.31433-8.7182-25.01323-23.56459-41.52776C376.00733,83.77745,355.2698,75.93722,343.11,71.50349A147.36065,147.36065,0,0,0,285.84909,62.996c-11.02724.36-30.49173,1.16769-52.61645,10.83409-14.43375,6.30379-23.40655,13.49433-36.62871,24.24062-20.94824,17.0413-23.705,24.13526-60.35132,59.3241-10.06148,9.65762-18.33191,17.26958-30.95705,24.7674-8.75331,5.19756-15.82971,8.10362-28.88506,13.40653-32.08962,13.03778-41.22623,15.67761-51.7267,23.0174C4.26234,232.87065,5.58506,248.44859,4.70709,251.80242a65.95877,65.95877,0,0,0-1.554,26.31261c2.6778,17.62076,12.1686,29.13967,18.05975,36.11071a99.29632,99.29632,0,0,0,28.88505,23.2134,184.58953,184.58953,0,0,0,23.66994,10.439Z",
    className: "colorf9e0c0 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4b0a2",
    d: "M330.82189,335.44441l-.45313-.80664c20.98145-11.78613,90.15332-55.9707,99.35449-129.69043a146.01507,146.01507,0,0,0-6.06836-62.124c-2.61425-7.665-8.73437-25.61524-24.44433-43.09571-19.24024-21.40918-41.209-29.42285-53.01172-33.72754a152.875,152.875,0,0,0-59.47168-8.83789c-10.90527.3545-31.2041,1.01368-54.63672,11.24512l-.37109-.84766c23.59668-10.30273,44.792-10.99121,54.97851-11.32128a153.67736,153.67736,0,0,1,59.81738,8.89257c11.87891,4.333,33.98926,12.39746,53.38282,33.97754,15.83691,17.62207,22,35.69727,24.63183,43.416a146.98449,146.98449,0,0,1,6.11133,62.53808C421.38634,279.211,351.899,323.60457,330.82189,335.44441Z",
    className: "colorf4c5a2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138.473,
    height: 105.091,
    x: 93.25,
    y: 53.272,
    fill: "#e1e5e3",
    rx: 6.296,
    className: "colore5e1e5 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138.474,
    height: 0.572,
    x: 93.25,
    y: 65.761,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7255",
    d: "M101.08034,62.85339c3.31476,0,3.32025-5.15151,0-5.15151-3.31475,0-3.32024,5.15151,0,5.15151Z",
    className: "colorffba55 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f75c3c",
    d: "M109.66621,62.85339c3.31475,0,3.32025-5.15151,0-5.15151-3.31476,0-3.32025,5.15151,0,5.15151Z",
    className: "colorf73c4f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f8f8f",
    d: "M117.67968,62.85339c3.31476,0,3.32025-5.15151,0-5.15151-3.31475,0-3.32025,5.15151,0,5.15151Z",
    className: "color4f66d0 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.576,
    height: 28.436,
    x: 101.08,
    y: 74.702,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.163,
    height: 0.572,
    x: 101.081,
    y: 112.904,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.163,
    height: 0.572,
    x: 101.081,
    y: 121.559,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.163,
    height: 0.572,
    x: 101.081,
    y: 130.213,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.163,
    height: 0.572,
    x: 101.081,
    y: 139.096,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.163,
    height: 0.572,
    x: 101.081,
    y: 147.751,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.429,
    height: 35.44,
    x: 170.227,
    y: 110.556,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 169.78,
    height: 128.851,
    x: 283.441,
    fill: "#e1e5e3",
    rx: 7.72,
    className: "colore5e1e5 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 169.78,
    height: 0.701,
    x: 283.441,
    y: 15.314,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7255",
    d: "M293.04148,11.74819c4.06419,0,4.07093-6.31623,0-6.31623-4.06419,0-4.07092,6.31623,0,6.31623Z",
    className: "colorffba55 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f75c3c",
    d: "M303.56853,11.74819c4.0642,0,4.07093-6.31623,0-6.31623-4.06419,0-4.07092,6.31623,0,6.31623Z",
    className: "colorf73c4f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f8f8f",
    d: "M313.39378,11.74819c4.0642,0,4.07093-6.31623,0-6.31623-4.06419,0-4.07092,6.31623,0,6.31623Z",
    className: "color4f66d0 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.184,
    height: 0.701,
    x: 293.042,
    y: 73.115,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.184,
    height: 0.701,
    x: 293.042,
    y: 83.727,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.184,
    height: 0.701,
    x: 293.042,
    y: 94.338,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.184,
    height: 0.701,
    x: 293.042,
    y: 105.23,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.184,
    height: 0.701,
    x: 293.042,
    y: 115.84,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.283,
    height: 43.452,
    x: 377.822,
    y: 70.237,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.758,
    height: 31.758,
    x: 291.896,
    y: 28.265,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.758,
    height: 31.758,
    x: 332.183,
    y: 28.265,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.758,
    height: 31.758,
    x: 373.432,
    y: 28.265,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.758,
    height: 31.758,
    x: 413.081,
    y: 28.265,
    fill: "#a2e6c8",
    className: "colora2aee6 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M432.83682,349.59749H.878a.878.878,0,1,1,0-1.75593H432.83682a.878.878,0,1,1,0,1.75593Z",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "140.869 263.529 90.66 263.529 90.66 235.498 140.778 235.498 140.869 263.529",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72.012,
    height: 68.146,
    x: 79.516,
    y: 164.372,
    fill: "#d6634b",
    rx: 6.041,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.712,
    height: 8.297,
    x: 75.167,
    y: 255.233,
    fill: "#d6634b",
    rx: 1.343,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.837,
    height: 5.236,
    x: 80.483,
    y: 263.529,
    fill: "#525252",
    rx: 1.343,
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.733,
    height: 52.197,
    x: 111.414,
    y: 268.765,
    fill: "#d6634b",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "119.147 325.108 168.73 342.576 168.73 336.293 119.147 320.962 111.414 320.962 61.791 336.293 61.791 342.576 111.414 325.108 119.147 325.108",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.358,
    height: 8.216,
    x: 109.602,
    y: 319.029,
    fill: "#e18774",
    rx: 1.343,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.613,
    height: 120.754,
    x: 206.582,
    y: 228.843,
    fill: "#525252",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 228.77,
    height: 5.839,
    y: 223.005,
    fill: "#525252",
    rx: 1.312,
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.613,
    height: 120.754,
    x: 15.182,
    y: 228.843,
    fill: "#525252",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c39086",
    d: "M9.10914,228.84336H220.181a0,0,0,0,1,0,0V243.973a2.62483,2.62483,0,0,1-2.62483,2.62483H11.734A2.62483,2.62483,0,0,1,9.10914,243.973V228.84336A0,0,0,0,1,9.10914,228.84336Z",
    className: "colorc38f86 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.37,
    height: 13.049,
    x: 55.002,
    y: 335.327,
    fill: "#d6634b",
    rx: 1.678,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.37,
    height: 13.049,
    x: 168.149,
    y: 335.327,
    fill: "#d6634b",
    rx: 1.678,
    transform: "rotate(-180 171.834 341.851)",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M360.14815,140.699V349.59749h47.22768V140.699a2.26621,2.26621,0,0,0-2.2662-2.26621H362.41435A2.26621,2.26621,0,0,0,360.14815,140.699Z",
    className: "color935b50 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 176.437,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 141.832,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6634b",
    d: "M402.10082 169.07716a1.4 1.4 0 1 1-1.97828 1.9783c.49842-.71631.5597-.98962.7782-1.2C401.11339 169.63939 401.38878 169.5757 402.10082 169.07716ZM400.12254 143.81428a1.4 1.4 0 1 1 1.97828 1.97831c-.71631-.49842-.98963-.55976-1.20008-.77826C400.6848 144.80177 400.62108 144.52629 400.12254 143.81428ZM365.4232 145.79259a1.4 1.4 0 1 1 1.97827-1.97831c-.49841.71631-.55981.9896-.77832 1.20005C366.41063 145.23036 366.13512 145.29405 365.4232 145.79259ZM367.40147 171.05546a1.4 1.4 0 1 1-1.97827-1.9783c.71631.49841.98951.55975 1.2.77826C366.83922 170.068 366.90294 170.34346 367.40147 171.05546ZM402.10082 203.68205a1.4 1.4 0 1 1-1.97828 1.9783c.49842-.71631.5597-.98962.7782-1.20007C401.11339 204.24428 401.38878 204.18059 402.10082 203.68205ZM400.12254 178.41914a1.4 1.4 0 1 1 1.97828 1.9783c-.71631-.49838-.98963-.55972-1.20008-.77823C400.6848 179.40666 400.62108 179.13118 400.12254 178.41914ZM365.4232 180.39744a1.4 1.4 0 1 1 1.97827-1.9783c-.49841.71631-.55981.98963-.77832 1.20007C366.41063 179.83525 366.13512 179.89894 365.4232 180.39744ZM367.40147 205.66035a1.4 1.4 0 1 1-1.97827-1.9783c.71631.49841.98951.55972 1.2.77823C366.83922 204.67286 366.90294 204.94835 367.40147 205.66035Z",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 245.647,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 280.252,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 153.186,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 257,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 291.605,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 187.791,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6634b",
    d: "M402.10082 272.8918a1.4 1.4 0 1 1-1.97828 1.97833c.49842-.71631.5597-.98962.7782-1.20007C401.11339 273.45405 401.38878 273.39033 402.10082 272.8918ZM400.12254 247.62892a1.4 1.4 0 1 1 1.97828 1.9783c-.71631-.49838-.98963-.55972-1.20008-.77823C400.6848 248.61644 400.62108 248.34092 400.12254 247.62892ZM365.4232 249.60722a1.4 1.4 0 1 1 1.97827-1.9783c-.49841.71631-.55981.98962-.77832 1.20007C366.41063 249.045 366.13512 249.10872 365.4232 249.60722ZM367.40147 274.87013a1.4 1.4 0 1 1-1.97827-1.97833c.71631.49841.98951.55975 1.2.77826C366.83922 273.88264 366.90294 274.15809 367.40147 274.87013ZM402.10082 307.49672a1.4 1.4 0 1 1-1.97828 1.97827c.49842-.71631.5597-.98963.7782-1.2C401.11339 308.05891 401.38878 307.99525 402.10082 307.49672ZM400.12254 282.23384a1.4 1.4 0 1 1 1.97828 1.97827c-.71631-.49841-.98963-.55975-1.20008-.77826C400.6848 283.22133 400.62108 282.94581 400.12254 282.23384ZM365.4232 284.21211a1.4 1.4 0 1 1 1.97827-1.97827c-.49841.71631-.55981.98956-.77832 1.2C366.41063 283.64992 366.13512 283.71357 365.4232 284.21211ZM367.40147 309.475a1.4 1.4 0 1 1-1.97827-1.97827c.71631.49841.98951.55975 1.2.77826C366.83922 308.4875 366.90294 308.763 367.40147 309.475Z",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99cdb6",
    d: "M373.85011,299.79989s23.053.46782,26.55521-3.42753c0,0-7.54917,27.04729-1.85007,40.31752L372.915,333.98222S375.91346,313.03472,373.85011,299.79989Z",
    className: "color7ca1b1 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f64d2b",
    d: "M368.20535,303.11341s23.053.46782,26.55521-3.42753c0,0-7.54917,27.04729-1.85007,40.31751l-25.64026-2.70765S370.2687,316.34823,368.20535,303.11341Z",
    className: "colorf65b2b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M371.08893,305.65963s23.053.46782,26.55521-3.42753c0,0-7.54916,27.04729-1.85006,40.31752L370.15382,339.842S373.15228,318.89445,371.08893,305.65963Z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7255",
    d: "M373.91131,197.606s23.053.46782,26.55521-3.42753c0,0-7.54916,27.04729-1.85006,40.31752l-25.64026-2.70766S375.97466,210.84079,373.91131,197.606Z",
    className: "colorffba55 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f64d2b",
    d: "M368.26655,200.91948s23.053.46782,26.55521-3.42753c0,0-7.54917,27.04729-1.85006,40.31751l-25.64026-2.70765S370.3299,214.1543,368.26655,200.91948Z",
    className: "colorf65b2b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M371.15013,203.4657s23.053.46782,26.55521-3.42753c0,0-7.54916,27.04729-1.85006,40.31752L370.215,237.648S373.21348,216.70052,371.15013,203.4657Z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 314.856,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 326.21,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6634b",
    d: "M402.10082 342.10158a1.4 1.4 0 1 1-1.97828 1.97833c.49842-.71631.5597-.98963.7782-1.20008C401.11339 342.66383 401.38878 342.60011 402.10082 342.10158ZM400.12254 316.8387a1.4 1.4 0 1 1 1.97828 1.97827c-.71631-.49835-.98963-.55969-1.20008-.7782C400.6848 317.82618 400.62108 317.55073 400.12254 316.8387ZM365.4232 318.817a1.4 1.4 0 1 1 1.97827-1.97827c-.49841.71631-.55981.98962-.77832 1.20007C366.41063 318.25477 366.13512 318.31849 365.4232 318.817ZM367.40147 344.07991a1.4 1.4 0 1 1-1.97827-1.97833c.71631.49841.98951.55975 1.2.77825C366.83922 343.09242 366.90294 343.36787 367.40147 344.07991Z",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.015,
    height: 31.206,
    x: 362.754,
    y: 211.042,
    fill: "#e18774",
    rx: 2.266,
    className: "colore19974 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.917,
    height: 4.759,
    x: 377.303,
    y: 222.396,
    fill: "#d6634b",
    rx: 0.878,
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6634b",
    d: "M402.10082 238.28694a1.4 1.4 0 1 1-1.97828 1.9783c.49842-.71631.5597-.98962.7782-1.20007C401.11339 238.84913 401.38878 238.78547 402.10082 238.28694ZM400.12254 213.024a1.4 1.4 0 1 1 1.97828 1.9783c-.71631-.49838-.98963-.55972-1.20008-.77823C400.6848 214.01155 400.62108 213.736 400.12254 213.024ZM365.4232 215.00233a1.4 1.4 0 1 1 1.97827-1.9783c-.49841.71631-.55981.98962-.77832 1.20007C366.41063 214.44014 366.13512 214.50383 365.4232 215.00233ZM367.40147 240.26524a1.4 1.4 0 1 1-1.97827-1.9783c.71631.49838.98951.55972 1.2.77823C366.83922 239.27772 366.90294 239.55324 367.40147 240.26524Z",
    className: "colord6694b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M297.79747,322.61524l.20169,8.94856s11.67822,9.39686,26.41986,11.9506c0,0,4.53477,2.12995,4.61016,5.47475l-44.23619-.1107-.391-17.34867-.20169-8.94857Z",
    className: "colorf9977a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M328.277,346.72263l-43.48451-.10637a1.02466,1.02466,0,0,0-1.02691,1.04775l.00485.21532a1.02467,1.02467,0,0,0,1.0219,1.00157l44.84851.10991S330.85954,347.6209,328.277,346.72263Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M310.581 346.27983a4.66585 4.66585 0 0 1-.15853-3.23424c.80624-2.42812 3.50128-3.42924 3.80559-3.53551a1.37053 1.37053 0 0 1 .91328 2.58222 3.86645 3.86645 0 0 0-2.20757 1.89936 2.38088 2.38088 0 0 0 .43737 1.98551 1.36386 1.36386 0 0 1-.40276 1.872 1.32387 1.32387 0 0 1-1.83187-.46213A7.07808 7.07808 0 0 1 310.581 346.27983ZM283.17336 332.01051a1.36631 1.36631 0 0 1 .35349-1.528 1.30635 1.30635 0 0 1 1.87112.17374c1.68051 2.01154 3.48778 3.05378 5.37331 3.09829 3.42476.081 6.19655-3.07684 6.22451-3.10791a1.29838 1.29838 0 0 1 1.8689-.08978 1.39391 1.39391 0 0 1 .13884 1.92284c-.14309.16813-3.56241 4.0998-8.20476 4.00146-2.69311-.05723-5.18038-1.42943-7.39305-4.07886A1.40363 1.40363 0 0 1 283.17336 332.01051Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M283.17385,332.01176a1.37649,1.37649,0,0,1,.22962-1.40618,1.29683,1.29683,0,0,1,1.87161-.07935c.33843.31287,8.286,7.77836,6.39179,16.43358a1.28854,1.28854,0,0,1-1.58414.98984,1.40547,1.40547,0,0,1-1.00372-1.65445c1.551-7.0939-5.48029-13.69692-5.5504-13.76286A1.40534,1.40534,0,0,1,283.17385,332.01176Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M246.65123,321.748l-1.6001,8.80665s2.59824,5.5702,16.52633,11.03333c0,0,9.47675,4.7178,8.87867,8.00955l-8.774-.18411-33.04627-4.55009,3.10214-17.07355,1.6001-8.80665Z",
    className: "colorf9977a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M269.2574,346.889l-10.80375.25679-29.20866-4.48a.80631.80631,0,0,0-.91887.67241l-.10086.645c-.06877.43974-.30913,1.1649.36275,1.50456l30.17951,4.10977h11.68861S271.6068,348.28771,269.2574,346.889Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M255.59021 346.20937a4.66584 4.66584 0 0 1 .49443-3.20015c1.27759-2.21666 4.11881-2.656 4.43827-2.69894a1.37053 1.37053 0 0 1 .37591 2.71305 3.86652 3.86652 0 0 0-2.54413 1.41716 2.38088 2.38088 0 0 0 .02958 2.0329 1.36385 1.36385 0 0 1-.77062 1.753 1.32389 1.32389 0 0 1-1.70169-.82072A7.07936 7.07936 0 0 1 255.59021 346.20937ZM230.43784 328.01386a1.36631 1.36631 0 0 1 .65324-1.42583 1.30634 1.30634 0 0 1 1.79807.54609c1.24215 2.30813 2.8032 3.69218 4.64136 4.11457 3.33866.76736 6.68833-1.76929 6.722-1.79411a1.29839 1.29839 0 0 1 1.84884.28749 1.39391 1.39391 0 0 1-.25028 1.91153c-.174.136-4.31339 3.30058-8.84135 2.27163-2.62671-.59708-4.78761-2.441-6.42293-5.48089A1.40388 1.40388 0 0 1 230.43784 328.01386Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    d: "M230.43807,328.01518a1.3765,1.3765,0,0,1,.50742-1.33139,1.29683,1.29683,0,0,1,1.84939.29826c.26868.37448,6.55446,9.28436,2.96015,17.38261a1.28852,1.28852,0,0,1-1.75069.65142,1.40547,1.40547,0,0,1-.6509-1.82236c2.94445-6.63771-2.617-14.51862-2.67242-14.5973A1.40532,1.40532,0,0,1,230.43807,328.01518Z",
    className: "color84382a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M325.2736,233.46176l-10.13319,5.46987h0a5.93607,5.93607,0,0,0-6.8355.90084l-2.34693,2.18932-13.14456-.41186c10.35309-5.95571,2.93089-42.67877-1.75558-58.94632-3.0398-10.55168-4.70621-22.85273-3.84758-29.09885.8331-6.067-.65634-6.09225-3.68123-14.665-1.18132-3.35032.46163-17.0151-1.14131-24.2271-2.038-9.1739,14.92236,4.60222,16.59031,7.999,4.6958,9.563,7.68,26.53243,7.012,32.98378-1.57947,15.25337,13.927,42.09006,15.92509,49.24768C325.00139,215.9625,328.53771,219.86967,325.2736,233.46176Z",
    className: "color376f92 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2f2f",
    d: "M319.5775 233.29191c-.1427-3.49682-.09058-6.96414-.09729-10.42913.01685-1.73243-.01074-3.46094-.04028-5.18894a37.07278 37.07278 0 0 0-.38477-5.1777 18.39129 18.39129 0 0 1 1.16333 5.12491 48.54175 48.54175 0 0 1 .26111 5.24282A59.16246 59.16246 0 0 1 319.5775 233.29191ZM302.384 239.20723c.17627-1.06354.39795-2.1131.58411-3.17133l.636-3.15234 1.27612-6.29181c.442-2.09226.82593-4.1926 1.21485-6.29178.20312-1.04965.35144-2.10455.50342-3.16251l.20129-1.59063.12317-1.60465c.0564.53327.11511 1.07212.14172 1.61243l.02259 1.62183c-.05384 1.07714-.11817 2.15686-.23035 3.22949-.21277 2.14795-.57446 4.27466-.99719 6.38412-.442 2.10608-.91895 4.204-1.511 6.27185C303.76866 235.13225 303.149 237.19194 302.384 239.20723ZM310.26939 209.45381c-.35339-2.01431-.694-4.02683-1.098-6.02853-.36755-2.007-.75842-4.00943-1.18945-6.00257-.84949-3.98761-1.70154-7.97442-2.77637-11.90344-1.01147-3.94391-2.16223-7.85126-3.50085-11.69449-.31092-.96982-.70215-1.90845-1.04969-2.86545l-.5371-1.42987-.6084-1.3992c-.41114-.92984-.749-1.89929-1.22242-2.801q-.6859-1.365-1.34594-2.75229a62.56955 62.56955 0 0 1 5.48523 10.9815 118.29324 118.29324 0 0 1 3.74572 11.70884c1.00013 3.97387 1.87134 7.97793 2.56214 12.01269C309.41319 201.31587 309.98338 205.3719 310.26939 209.45381Z",
    className: "color10394f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M251.73831,178.01612,231.09056,323.33086c-.14507,3.35293,13.96057,7.22375,15.28,3.84l27.23652-124.88575,8.24349,116.698c.06333,1.05618.85672,8.64731,1.91479,8.64731h14.112a.98917.98917,0,0,0,.97607-.77695,41.6961,41.6961,0,0,0,.471-7.00881l-1.32833-141.82852Z",
    className: "color376f92 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2f2f",
    d: "M246.40453 253.7567a25.04379 25.04379 0 0 0 3.469.60943 18.636 18.636 0 0 0 3.49182.06327 12.84952 12.84952 0 0 0 3.3888-.73581 10.758 10.758 0 0 0 2.985-1.80375 8.60051 8.60051 0 0 1-2.86194 2.10166 11.97421 11.97421 0 0 1-3.47778.8551A16.25712 16.25712 0 0 1 246.40453 253.7567ZM244.53758 260.424c1.35352-.041 2.7002-.15295 4.03968-.29058a33.93649 33.93649 0 0 0 3.98205-.62635 18.98611 18.98611 0 0 0 3.83679-1.163 10.06406 10.06406 0 0 0 3.343-2.1872 8.69062 8.69062 0 0 1-3.20972 2.48072 17.3257 17.3257 0 0 1-3.88256 1.27877 29.283 29.283 0 0 1-8.10926.5076ZM281.34117 254.68739a25.85716 25.85716 0 0 0 3.00379.31305 20.368 20.368 0 0 0 2.99694-.06717 14.99623 14.99623 0 0 0 5.73365-1.64465 10.10318 10.10318 0 0 1-2.697 1.42053 13.253 13.253 0 0 1-2.99793.64093A15.29994 15.29994 0 0 1 281.34117 254.68739ZM281.34117 260.43565a21.53283 21.53283 0 0 0 3.50513.67722 26.16405 26.16405 0 0 0 3.55237.18121 27.90092 27.90092 0 0 0 3.55041-.24927c1.18286-.13473 2.34912-.37857 3.52674-.60916a21.34351 21.34351 0 0 1-3.478.92783 23.17923 23.17923 0 0 1-3.59473.34918 21.9879 21.9879 0 0 1-3.60217-.28217A14.21124 14.21124 0 0 1 281.34117 260.43565ZM268.00658 198.018c1.37426 1.07657 2.80749 2.07025 4.25793 3.029a48.53711 48.53711 0 0 0 4.48523 2.64972 32.98864 32.98864 0 0 0 4.76172 2.07828 20.54394 20.54394 0 0 0 5.089 1.04382 16.97749 16.97749 0 0 1-5.18665-.7366 29.72108 29.72108 0 0 1-4.858-2.01459 41.44359 41.44359 0 0 1-4.47192-2.7554A38.49021 38.49021 0 0 1 268.00658 198.018ZM258.1389 206.81886c1.99561-.32144 3.986-.60236 5.9419-1.04355a24.74132 24.74132 0 0 0 2.89453-.77261 7.28716 7.28716 0 0 0 2.63135-1.38413 5.96539 5.96539 0 0 1-2.51795 1.68592 19.70341 19.70341 0 0 1-2.91907.87988A29.0687 29.0687 0 0 1 258.1389 206.81886ZM277.30345 205.21873a6.042 6.042 0 0 0 1.59448 3.2602 12.55645 12.55645 0 0 0 2.8042 2.36306c.507.34781 1.054.63852 1.58631.94919.55664.26856 1.10534.55386 1.66845.812 1.12757.51776 2.29029.95179 3.45154 1.41638-.60522-.15066-1.2041-.32775-1.80871-.49163-.59766-.18387-1.1781-.42005-1.76966-.62833-.58972-.2142-1.1438-.51495-1.71753-.77-.54882-.30542-1.11267-.58939-1.639-.937a11.84876 11.84876 0 0 1-2.82386-2.51035A5.48059 5.48059 0 0 1 277.30345 205.21873Z",
    className: "color10394f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M246.23831,117.77394s3.58209-2.42381,5.88-11.68211,3.11943-16.78925.05253-10.80472l-2.26157,4.5991s-1.424-7.53622-1.87917-12.10011a5.67953,5.67953,0,0,0-4.46022-5.07719c-2.23916-.43276-3.76651.5729-4.261,5.918-.73965,7.99436-.90262,12.23852-.50756,14.26586.13686.70235,2.23107,8.17961,2.23107,8.17961Z",
    className: "colorf9977a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd745e",
    d: "M250.40453 104.50441a7.1555 7.1555 0 0 1-.30884-1.14011 11.53364 11.53364 0 0 1-.1731-1.146c-.03283-.38382-.06628-.76706-.06311-1.155a8.6928 8.6928 0 0 1 .04981-1.17713 5.08454 5.08454 0 0 1 .39612 1.12 8.06786 8.06786 0 0 1 .19836 1.1535 8.56562 8.56562 0 0 1 .038 1.16779A5.883 5.883 0 0 1 250.40453 104.50441ZM246.30956 95.41841a24.22675 24.22675 0 0 1-.49244-2.82639c-.12451-.94836-.18823-1.90286-.22326-2.85934a24.27709 24.27709 0 0 1 .06665-2.873 13.17438 13.17438 0 0 1 .50561-2.83127c-.1 1.91089-.04956 3.79007.0116 5.68607l.08569 2.844C246.28893 93.50853 246.31786 94.45939 246.30956 95.41841ZM243.50206 95.07515a23.32477 23.32477 0 0 1-.6792-3.069 26.47906 26.47906 0 0 1-.31885-3.132 17.73289 17.73289 0 0 1 .12293-3.15808 7.418 7.418 0 0 1 .94287-3.00717 10.745 10.745 0 0 0-.49512 3.04843c-.038 1.02826-.04162 2.06009.01294 3.09323C243.16393 90.91865 243.35936 92.9839 243.50206 95.07515ZM240.96788 94.12935a16.99522 16.99522 0 0 1-.60974-2.55808 22.518 22.518 0 0 1-.28564-2.61572 19.48409 19.48409 0 0 1 .05029-2.63556 12.84384 12.84384 0 0 1 .48926-2.58908c-.02124.87976-.05054 1.74228-.04 2.60724.02453.86459.03467 1.72647.084 2.58938l.14673 2.59208Z",
    className: "colordd765e svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7255",
    d: "M245.87107,110.543l-5.86718-1.33346-7.791,27.92759c-2.5791,9.245,9.38629,15.357,15.37586,7.85722,2.3822-2.98291,4.05718-5.486,4.41619-6.98207l1.3335,15.73484-13.2804,90.509a66.68154,66.68154,0,0,0,29.5486,7.63372,70.802,70.802,0,0,0,32.1093-7.63372c-.39271-31.67116-3.75917-58.70145-3.62985-90,.01044-2.52693,2.21535-24.07917,2.19016-26.11142l11.95983,15.71866c5.64185,6.68347,16.04285,6.68347,21.11-5.051l8.00079-17.60168-11.20111-6.934-8.00073,12.80122-16.19287-24.48206A20.93934,20.93934,0,0,0,288.48741,93.208H264.07365a13.17781,13.17781,0,0,0-11.14574,6.14738Z",
    className: "colorffba55 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e64a2a",
    d: "M233.90074 131.0869c1.65528-3.62192 3.57227-7.0914 5.55347-10.5235 2.0072-3.4169 4.08008-6.79556 6.41687-10.02039-1.6532 3.62314-3.57056 7.09247-5.55347 10.52353C238.3087 124.48237 236.23558 127.86088 233.90074 131.0869ZM252.005 138.01231c-.20618-2.28912-.30286-4.57821-.38281-6.86734-.09143-2.28909-.10437-4.57818-.11682-6.86731.01111-2.28909.02441-4.57821.115-6.86731l.13952-3.43368c.08313-1.14453.13172-2.2891.24512-3.43366.1134 1.14456.16211 2.28913.24512 3.43366l.13952 3.43368c.09058 2.2891.10389 4.57822.11512 6.86731-.01258 2.28913-.02552 4.57822-.117 6.86731C252.30785 133.4341 252.21129 135.72319 252.005 138.01231ZM300.27623 128.1447c-1.64075-2.34027-3.19116-4.73477-4.72546-7.13892-1.54615-2.39706-3.02478-4.83459-4.50269-7.27261l-.025-.04126-.01282-.03644a20.5819 20.5819 0 0 1-.99524-4.39221 17.69186 17.69186 0 0 1 .05164-4.48874 13.32291 13.32291 0 0 1 1.4176-4.25122 11.23482 11.23482 0 0 1 2.9248-3.31488 12.25362 12.25362 0 0 0-2.48254 3.54022 12.74309 12.74309 0 0 0-1.08911 4.1217 19.52845 19.52845 0 0 0 .12292 4.275 20.65776 20.65776 0 0 0 .98035 4.15231l-.03772-.07733c1.45569 2.45126 2.91064 4.90308 4.2981 7.39535C297.60021 123.10084 298.98351 125.59566 300.27623 128.1447ZM255.20531 170.54875c1.53906.50665 3.08691.96246 4.65991 1.32053.78015.19885 1.57019.35946 2.35327.54086l2.37232.43738a63.039 63.039 0 0 0 9.57666.84817c1.60315.06738 3.20092-.05545 4.80175-.12222.79773-.06455 1.59229-.1673 2.38953-.24887l1.19482-.13379 1.18457-.20343c.78882-.142 1.58558-.25708 2.37134-.42139l2.33557-.598c.3899-.09894.78882-.17322 1.173-.29282l1.14685-.38049q1.14587-.38723 2.31067-.746a38.52968 38.52968 0 0 1-9.19348 3.1943l-1.1941.27494c-.40173.06961-.80737.11578-1.21118.17477-.80884.107-1.6167.2349-2.42822.32425-1.62952.098-3.26025.22955-4.89392.178a48.60679 48.60679 0 0 1-9.708-1.09546A42.78179 42.78179 0 0 1 255.20531 170.54875ZM328.81236 131.0869a16.78685 16.78685 0 0 0-2.84314-3.61383 3.25987 3.25987 0 0 0-1.81225-.88831 2.25713 2.25713 0 0 0-1.65064.82318l-.02819-.68851a9.47152 9.47152 0 0 1 1.759 2.5347 13.45306 13.45306 0 0 1 1.01306 2.84308 14.98612 14.98612 0 0 1 .09509 5.9151l-.09619-1.46252c-.06262-.48334-.09595-.96567-.18188-1.44065a19.58163 19.58163 0 0 0-.62122-2.79739 15.93259 15.93259 0 0 0-1.07165-2.616 10.46869 10.46869 0 0 0-1.56226-2.25915l-.38086-.4036.35254-.28518a4.11623 4.11623 0 0 1 1.07214-.80378 1.67422 1.67422 0 0 1 .665-.22384 1.81712 1.81712 0 0 1 .70838-.02988 3.77386 3.77386 0 0 1 2.24328 1.2601 9.85862 9.85862 0 0 1 1.38928 1.96979A13.32156 13.32156 0 0 1 328.81236 131.0869Z",
    className: "colore6952a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M331.55664,115.15009l5.87874-15.00806,9.26926-12.359a1.43259,1.43259,0,0,1,2.0129-.281h0a1.43257,1.43257,0,0,1,.32331,1.938L343.836,97.20841s7.23236-5.10072,7.74769,3.79021a2.48683,2.48683,0,0,1-2.00691,2.58551,7.41271,7.41271,0,0,0-2.45158.91387s.889,8.44525-4.62266,8.71194l-2.30944,7.28652Z",
    className: "colorf9977a svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8066",
    d: "M336.09535 103.56305s.84518-6.12891.27166-7.69534a1.7438 1.7438 0 0 1 .0845-1.30179c.602-1.34865 1.8586-3.02889 2.91472 3.00164l-1.93085 2.57447ZM267.52824 93.64169 266.86151 58.305h26.26917V79.30821a8.33535 8.33535 0 0 1-8.33535 8.33535h-.59883l.13334 5.99813Z",
    className: "colorf9977a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dd745e",
    points: "284.196 87.644 279.996 87.644 284.33 93.642 284.196 87.644",
    className: "colordd765e svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f1f",
    d: "M267.41507,87.64356s4.27106,6.48579,17.44816-13.2037c0,0-5.41879-2.95571-.6336-6.38167a2.76366,2.76366,0,0,1,1.46089-.51737c.958-.05053,2.41723.095,2.50636,1.43185l4.9338-10.66769s5.06715,1.20012,4.80046-4.80045c0,0,5.2005-3.067-1.20011-5.73389,0,0,.26669-7.46737-6.80065-2.00019,0,0-4.80046-11.06772-17.0683,4.66712,0,0-20.00191,1.73349-10.53434,18.40175Z",
    className: "color1e1d22 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.137,
    cy: 76.484,
    r: 2.784,
    fill: "#f75c3c",
    className: "colorf73c4f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M291.60613,238.13612l-11.16,2.83819h0a5.93608,5.93608,0,0,0-6.84914-.79049l-2.80933,1.552-12.64876-3.59973c11.49158-3.25586,13.23359-40.681,12.64875-57.6-.37934-10.97426.99929-23.31087,3.35281-29.16,2.28516-5.68164.84668-6.06873,0-15.12-.33008-3.5371,4.59036-16.3907,4.79154-23.776.25683-9.39405,1.77-20.633,10.51414-21.83755,5.957-.82177,10.06593,4.37544,11.34132,6.5605,0,0-2.6882-2.13431-5.1241-1.2607-5.336,1.9137-3.37852,24.63459-2.58776,28.33524,2.22623,10.41846.98915,27.60389-1.22946,33.69846-5.24564,14.40984,3.26038,44.21431,3.45569,51.643C295.6026,221.09717,298.08125,225.74775,291.60613,238.13612Z",
    className: "color376f92 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2f2f",
    d: "M286.12279 236.58461c.713-3.42639 1.60766-6.77667 2.44482-10.139.43811-1.67621.83228-3.35941 1.22425-5.04263a37.07718 37.07718 0 0 0 .88732-5.11557 18.3862 18.3862 0 0 1-.11938 5.2539 48.51382 48.51382 0 0 1-1.02319 5.14868A59.16568 59.16568 0 0 1 286.12279 236.58461ZM268.00658 238.13585c.42981-.98862.90039-1.95264 1.33862-2.93369l1.38428-2.90265 2.76953-5.79178c.93823-1.92169 1.82178-3.86535 2.71008-5.8067.45276-.96856.8534-1.95563 1.25842-2.94476l.5824-1.49378.51013-1.52636c-.07507.531-.14941 1.06787-.25512 1.59839l-.373 1.57855c-.31445 1.03161-.63965 2.06317-1.00952 3.07623-.72937 2.03153-1.598 4.00617-2.52149 5.94925-.94152 1.93509-1.91491 3.85373-2.99255 5.71527C270.34166 234.52061 269.23912 236.36744 268.00658 238.13585Z",
    className: "color10394f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f1f",
    d: "M261.72611,55.42809c-4.68,2.87689-8.72363,4.19718-10.44,14.708-.94159,5.76614-.94159,5.76614-.72,17.04.52918,26.91728-2.3764,32.48108-3.6,34.56-2.90033,4.92753-4.52319,4.15988-8.63995,11.04-3.202,5.35132-6.427,10.74112-6.24005,17.52.2113,7.66243,4.77862,16.98154,12.96,20.4,11.41278,4.76864,25.00134-3.97445,30.72-12.96,7.21753-11.34059,4.98731-27.91925,4.32-32.88-.50549-3.75765-1.66565-9.57035-.48-17.52.129-.8651.4378-2.77452,2.64-10.32,4.99634-17.11928-2.9729-25.06607-7.68-31.44C270.67,60.30024,264.43492,53.7629,261.72611,55.42809Z",
    className: "color1e1d22 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2f2f",
    d: "m286.12279 150.05613.62488-9.91278c.18811-3.30218.40783-6.59933.55664-9.8988.15417-3.29852.25525-6.59686.27075-9.89447-.02124-1.64655-.04126-3.29626-.18677-4.93546a23.11219 23.11219 0 0 0-.78784-4.87161c1.29431 3.08365 1.52429 6.48792 1.74353 9.78668.16638 3.32291.09119 6.64634-.04138 9.962-.17468 3.31384-.42114 6.6221-.79212 9.91724C287.14842 143.50438 286.71837 146.79255 286.12279 150.05613ZM282.89867 211.19758c.14758-2.03976.30713-4.07464.40271-6.11447.13208-2.0361.24048-4.07345.30774-6.11154.147-4.07443.29113-8.14877.2052-12.22122-.02076-4.07147-.18567-8.14145-.54822-12.19492-.06543-1.01632-.21643-2.022-.32044-3.03479l-.17285-1.51761-.24939-1.50521c-.17248-1.002-.264-2.02451-.50366-3.01432q-.33306-1.49092-.63537-2.99719a62.57175 62.57175 0 0 1 2.64648 11.98654 118.29943 118.29943 0 0 1 .78235 12.26847c.00244 4.09777-.12744 8.19348-.4397 12.275C284.04942 203.096 283.615 207.16887 282.89867 211.19758Z",
    className: "color10394f svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M244.35056 243.29086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM250.29056 245.45086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM256.95056 247.61086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM263.97056 248.69086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM272.07056 249.05086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM280.89056 248.15086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM289.35056 246.17086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM296.37056 244.19086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM330.75056 120.35086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM334.35056 122.51086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM337.95056 124.67086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM241.83056 113.69086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3Z",
    className: "color376f92 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7255",
    d: "M233.13056 323.21086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM238.39386 325.91086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM244.41056 326.33086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM285.93056 326.15086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM291.45056 326.15086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3ZM296.73056 325.79086a1.5009 1.5009 0 0 0 0-3 1.5009 1.5009 0 0 0 0 3Z",
    className: "colorffba55 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.2e32c76001639a697916a18c207ffa59.svg";
export { ForwardRef as ReactComponent };